{
  "ui": {
    "feedback": "Visszajelzés",
    "credits": "Közreműködők",
    "currentMaintainer": "Jelenlegi karbantartó",
    "maintainerPeriod": "2026-tól",
    "originalTeam": "Eredeti csapat",
    "creditsCampaigns": "Dzsungel és karácsony",
    "moreSettings": "További beállítások",
    "chooseLanguage": "Válassz nyelvet",
    "notebookTools": "A füzet eszközei",
    "visualGuide": "Képes útmutató",
    "templeSoon": "Hamarosan",
    "playAdventure": "Játék",
    "story": "A történet",
    "loadingAdventure": "Készülünk a kalandra…",
    "storyOpening": "Iskolai kirándulás a dzsungelbe. Marco és Sophia a barátaikkal felfedezőútra indulnak. Egy színes madár felkelti Marco figyelmét, és ő követi a fák közé. Hirtelen egyedül marad. Segíts a felfedezőknek megtalálni az utat!",
    "storyEnding": "Marco és Sophia együtt érnek az elveszett templomhoz. Titokzatos arc őrzi a bejáratot. Új kaland vár rájuk!",
    "blockCategories": "A füzet fülei",
    "actions": "Műveletek",
    "loops": "Ciklusok",
    "conditions": "Feltételek",
    "title": "Run Marco! — Kaland a füzetedben",
    "home": "Run Marco kezdőlap",
    "map": "Kalandtérkép",
    "worlds": "Válassz kalandot",
    "notebook": "A füzetem",
    "notebookToggle": "Füzet kinyitása vagy becsukása",
    "notebookOpen": "Füzet kinyitása",
    "notebookClose": "Az ösvény figyelése",
    "page": "{number}. oldal",
    "level": "{number}. útvonal",
    "run": "Indulás!",
    "stop": "Állj",
    "step": "Egy lépés",
    "stepTitle": "Egy utasítás végrehajtása",
    "reset": "Vissza a rajthoz",
    "add": "Hozzáadás",
    "addLabel": "Válassz egy hozzáadandó blokkot",
    "addHint": "Kapcsold össze a blokkokat, majd nyomd meg a Játék gombot.",
    "undo": "Visszavonás",
    "clear": "Új oldal",
    "hint": "Egy kis segítség",
    "help": "Hogyan játssz",
    "settings": "Beállítások",
    "language": "A játék nyelve",
    "blockLanguage": "A blokkok nyelve",
    "blockLanguageNote": "A blokkokhoz másik nyelvet is választhatsz.",
    "musicOn": "Hang bekapcsolása",
    "musicOff": "Hang kikapcsolása",
    "sound": "Zene és hanghatások",
    "speed": "A kaland sebessége",
    "chooseExplorer": "Válassz felfedezőt",
    "explorer": "Felfedező",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Bezárás",
    "done": "Fedezzük fel!",
    "loading": "Keressük az ösvényt…",
    "loadError": "A kalandot nem sikerült betölteni. Töltsd újra az oldalt, és próbáld meg újra.",
    "imageError": "Néhány képet nem sikerült betölteni. Töltsd újra az oldalt.",
    "gemGoal": "Keresd meg a drágakövet",
    "goal": "Találd meg az aranycsillagot",
    "cover": "Világíts meg minden mezőt pontosan egyszer",
    "lit": "{count} / {total} mező világít",
    "explored": "{count} / {total} útvonal felfedezve",
    "facing": "Irány: {direction} {arrow}",
    "boardLabel": "{name} a(z) {level} útvonalon. Irány: {direction}. {steps}. {objective}.",
    "up": "fel",
    "down": "le",
    "left": "balra",
    "right": "jobbra",
    "steps_one": "{count} lépés",
    "steps_other": "{count} lépés",
    "blocks_one": "{count} blokk",
    "blocks_other": "{count} blokk",
    "stars_one": "{count} csillag",
    "stars_other": "{count} csillag",
    "place": "Blokkok hozzáadása",
    "atEnd": "A végére",
    "insideRepeat": "A(z) {number}. ismétlésbe",
    "insideIf": "A(z) {number}. ha blokkba",
    "insideElse": "A(z) {number}. különben blokkba",
    "readyFirst": "Egy kis lépés. Adj hozzá egy előre blokkot, és indulás!",
    "ready": "Merre menjünk? Készíts tervet a füzetedben.",
    "back": "Vissza a rajtnál. A blokkjaid készen állnak egy új próbára.",
    "empty": "Először adj egy blokkot a füzetedhez.",
    "win": "Megtaláltad az utat!",
    "winCover": "Kivilágítottad az ösvényt!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Micsoda kaland!",
    "simpler": "Meg tudod oldani kevesebb blokkal?",
    "complete": "Útvonal teljesítve! A legjobb csillagaidat elmentettük.",
    "next": "Következő útvonal",
    "allWorlds": "További kalandok",
    "replay": "Új játék",
    "shortGoal": "Majdnem! Adj hozzá még néhány blokkot, hogy elérd a csillagot.",
    "shortGem": "Majdnem! Adj hozzá még néhány blokkot, hogy elérd a drágakövet.",
    "shortCover": "Néhány mező még sötét. Hogyan érjük el őket?",
    "checking": "Figyeljük az ösvényt…",
    "paused": "Megálltunk. A Játék elölről kezdi az útvonalat.",
    "going": "Gyerünk!",
    "stepped": "Egy lépéssel közelebb. Folytasd az Egy lépés vagy a Játék gombbal.",
    "clueCover": "Indulj a széléről, és járd be az egész alakzatot. Ugrással átugorhatsz egy mezőt anélkül, hogy megvilágítanád.",
    "clueCondition": "Nézd az előtted lévő ösvényt. Egy feltétel segít a felfedezőnek eldönteni, mit tegyen.",
    "clueRepeat": "Mely lépések ismétlődnek? Tedd ezt a mintát egy ismétlőblokkba.",
    "clueForward": "Az előre arra vezet, amerre a felfedező néz. Számold meg a mezőket a csillagig.",
    "clueGem": "Az előre arra vezet, amerre a felfedező néz. Számold meg a mezőket a drágakőig.",
    "clueTurn": "A fordulás csak az irányt változtatja. Kövesd az ösvényt az ujjaddal.",
    "mapNote": "Válassz útvonalat. A legjobb csillagaid megmaradnak.",
    "mapLevel": "{number}. útvonal: {name}. {stars}.",
    "locked": "Teljesítsd az előző útvonalat, hogy megnyisd ezt.",
    "soundBlocked": "Koppints a hang gombjára, hogy hallhasd a kalandot.",
    "clearTitle": "Kezdjünk új oldalt?",
    "clearNote": "Az útvonal blokkjai törlődnek. A Visszavonás visszahozhatja őket.",
    "keep": "Blokkjaim megtartása",
    "clearConfirm": "Blokkok törlése",
    "fresh": "Új oldal. Merre vezet a következő terved?",
    "localProgress": "Az eredményed ezen az eszközön tárolódik.",
    "helpBuild": "Készíts tervet",
    "helpBuildText": "Húzz blokkokat a füzetbe és kapcsold össze őket, vagy koppints rájuk. Válaszd az ismétlés belsejét, ha lépéseket adnál egy ciklushoz.",
    "helpTurn": "Kövesd a felfedeződet",
    "helpTurnText": "Az előre a nézés irányát követi. A balra és jobbra helyben fordít. Az ugrás két mezőt tesz meg.",
    "helpTry": "Próbáld, figyeld, próbáld újra",
    "helpTryText": "A Játék kipróbálja a tervedet, az Egy lépés egy utasítást hajt végre. A görbe nyíl visszavisz a rajthoz, és megtartja a blokkokat.",
    "helpWorlds": "Minden kalandnak van célja",
    "helpWorldsText": "A Dzsungelben keresd meg a drágakövet. A karácsonyi kalandban minden szabad mezőt egyszer világíts meg. A Templomban és az Égei-tengernél végezd el a javításokat és a látható feladatokat, majd érd el a kijáratot.",
    "noTrail": "Arra nincs ösvény! Próbálj előbb elfordulni.",
    "broken": "Az a híd törött. Át tudod ugrani?",
    "blocked": "Valami elállja az utat. Próbálj ugrani vagy másfelé menni.",
    "alreadyLit": "Az a mező már világít. Minden mezőt csak egyszer érints.",
    "loopError": "Ez a terv végtelenül ismétlődik. Próbáld megváltoztatni a ciklust.",
    "repeatError": "Válassz 1 és 99 közötti ismétlésszámot.",
    "unsupported": "Távolítsd el a nem támogatott blokkot, és próbáld újra.",
    "connect": "Kapcsold a blokkokat egyetlen láncba, majd nyomd meg a Játék gombot.",
    "path": "ösvény",
    "backpack": "Hátizsák",
    "templeGems": "A templom drágakövei",
    "gemsCollected": "Drágakövek: {count} / {total}",
    "gemsReady": "Minden drágakövet összegyűjtöttél!",
    "aegeanTitle": "Az Égei-tenger titkai",
    "harbour": "Kikötő",
    "aegeanDescription": "Fedezd fel a kikötőt: javítsd meg az állomásokat, használd újra az eljárásokat, és adj át egy számot minden munkához.",
    "templeBetaNote": "Béta · A feladványok és leckék átdolgozás alatt állnak",
    "aegeanBetaNote": "Béta · A kikötő első 3 pályája",
    "seasonal": "Szezonális kaland",
    "choosePreview": "Válassz bemutatópályát",
    "repairs": "Javítások",
    "reachExit": "Érd el a kijáratot",
    "taskRequirements": "A feladat céljai",
    "lessonGuided": "Vezetett gyakorlat · egészítsd ki a megadott programot",
    "lessonRepair": "Hibakeresés · javítsd ki a megadott programot",
    "lessonChallenge": "Kihívás · készíts saját programot",
    "acc_define_parameter": "Eljárás",
    "acc_call_argument": "Eljárás hívása",
    "acc_repeat_parameter": "Ismétlés bemenettel",
    "parameter": "paraméter",
    "argument": "átadott érték",
    "callInput": "A hívás bemenete",
    "inputWaiting": "Futtasd a programot vagy egyenként az utasításokat a következő bemenet megtekintéséhez.",
    "argumentMismatch": "A paraméteres eljárás számot tartalmazó hívást igényel. Paraméter nélkül egyszerű hívást használj.",
    "unsetParameter": "A paramétert csak az azt fogadó eljáráson belül használd. A paraméterek elkülönülnek a közös memóriától.",
    "memoryObjective": "Ellenőrizd a javítási naplót és a kijárat feltételeit. Minden megfelelő programot elfogadunk.",
    "gate": "Az út el van zárva. Ellenőrizd a befejezetlen javításokat.",
    "noPickup": "Állj az eszközre, mielőtt felveszed.",
    "creditLead": "Csapatvezetés és szoftverfejlesztés",
    "creditArt": "Illusztráció és környezet",
    "creditAnimation": "Animáció",
    "creditUX": "Felület- és felhasználóiélmény-tervezés",
    "creditDesign": "Játéktervezés",
    "creditStory": "Történetírás",
    "creditAudio": "Zene és hangtechnika",
    "lightLamp": "Lámpa meggyújtása",
    "oilLamp": "Olajmécses",
    "dustyStation": "poros állomás",
    "betaLabel": "Béta",
    "noLamp": "Állj egy kialudt lámpára, mielőtt meggyújtod.",
    "collected": "Eszköz felvéve · használatra kész",
    "dustyPrompt": "Állj egy poros állomásra, mielőtt használod az ecsetet.",
    "lampMissing": "Először vedd fel az olajmécsest. Nézd meg a hátizsákodat.",
    "recursiveRoutine": "Ez az eljárás önmagát hívja. Használj másik eljárást; a rekurzív hívások még nem érhetők el."
  },
  "content": {
    "jungle.title": "Dzsungelexpedíció",
    "jungle.description": "Kövesd az ösvényt az elveszett templomig.",
    "jungle-1": "Első lépések",
    "jungle-2": "Kicsit messzebb",
    "jungle-3": "A sarkon túl",
    "jungle-4": "Válts irányt",
    "jungle-5": "Kövesd az ösvényt",
    "jungle-6": "Új útvonal",
    "jungle-7": "Új ösvények",
    "jungle-8": "Dzsungelkereszteződés",
    "jungle-9": "Találd meg az utad",
    "jungle-10": "Gondolkodj előre",
    "jungle-11": "A hosszú ösvény",
    "jungle-12": "Kanyargós útvonal",
    "jungle-13": "Bátor ugrás",
    "jungle-14": "Minták bukkannak fel",
    "jungle-15": "Ismételd a ritmust",
    "jungle-16": "Válassz ösvényt",
    "jungle-17": "Nézz, mielőtt ugrasz",
    "jungle-18": "Olvasd az ösvényt",
    "jungle-19": "Okos kerülő",
    "jungle-20": "A lombkorona alatt",
    "jungle-21": "Hídépítő",
    "jungle-22": "A folyón túl",
    "jungle-23": "Fedezd fel a romokat",
    "jungle-24": "Kő és fa",
    "jungle-25": "Nagyobb ugrás",
    "jungle-26": "Kövesd a nyomokat",
    "jungle-27": "Magasabbra",
    "jungle-28": "Folytasd a felfedezést",
    "jungle-29": "Tekergő ösvények",
    "jungle-30": "A titkos kert",
    "jungle-31": "Rejtett minták",
    "jungle-32": "Ősi ösvények",
    "jungle-33": "Az utolsó fordulók",
    "jungle-34": "A templom felé",
    "jungle-35": "Mindjárt ott vagyunk",
    "jungle-36": "Az elveszett templom",
    "winter.title": "Téli ösvény",
    "winter.description": "Gyújts fényt minden lábnyomban.",
    "winter-1": "Lépések a hóban",
    "winter-2": "Másik irány",
    "winter-3": "Fagyott sarkok",
    "winter-4": "A hosszú kerülő",
    "winter-5": "Hópehely",
    "winter-6": "Téli ciklusok",
    "winter-7": "Jégfelfedező",
    "winter-8": "Kanyarok és fordulók",
    "winter-9": "Jeges logika",
    "winter-10": "Mintakereső",
    "winter-11": "Az ösvény mestere",
    "winter-12": "Téli csoda",
    "temple.title": "Az elveszett templom",
    "temple.description": "Negyven összekapcsolt terem. Állítsd helyre az égi szerkezetet eszközökkel, memóriával és saját eljárásokkal."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "A kuka üres",
    "OPEN_TRASH": "Kuka megnyitása",
    "BLOCK_LABEL_BEGIN_STACK": "Lánc eleje",
    "WORKSPACE_LABEL_1_STACK": "1 blokklánc",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 blokklánc",
    "ARIA_TYPE_FIELD_NUMBER": "szám",
    "ARIA_TYPE_FIELD_DROPDOWN": "legördülő lista",
    "ARIA_TYPE_FIELD_IMAGE": "kép",
    "WORKSPACE_LABEL_PLAIN": "A füzetem",
    "FIELD_LABEL_EDIT_PREFIX": "%1 szerkesztése",
    "BLOCK_LABEL_HAS_INPUT": "van bemenete",
    "BLOCK_LABEL_HAS_INPUTS": "vannak bemenetei",
    "BLOCK_LABEL_HAS_BRANCHES": "%1 ága van",
    "FIELD_LABEL_OPTION_INDEX": "%1. lehetőség",
    "INPUT_LABEL_EMPTY": "Üres",
    "BLOCK_LABEL_DISABLED": "letiltva",
    "BLOCK_LABEL_COLLAPSED": "összecsukva",
    "BLOCK_LABEL_BEGIN_PREFIX": "Kezdet: %1",
    "INPUT_LABEL_END_STATEMENT": "Vég: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "szöveg",
    "ARIA_TYPE_FIELD_INPUT": "bemenet",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "bemenet neve",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "eljárás neve"
  }
}
